/**
 * Global top-bar header for the Kelly AI route: the "Kelly AI" title and nothing else.
 *
 * Nothing here owns the panel collapse/open controls, and removing the tab strip (APP-3445) did not touch them
 * — APP-3397 had already moved them page-local, and they stay exactly where they were: the Collapse button
 * lives at the panel's top-right (side-panel.tsx) and the Open button on the collapsed rail (collapsed-rail.tsx),
 * both wired to `agentChat.panelCollapsed` by conversation-surface.tsx.
 */

import { useSelector } from "react-redux"
import HomeHeader from "modules/home-header"
import { getModel } from "modules/home-layout/selectors/model"
import "./header.scss"

interface KellyAiHeaderProps {
  account: string
}

export default function KellyAiHeader({ account }: KellyAiHeaderProps) {
  // The account's selected/default risk model — passed to HomeHeader for the HelpMenu, like DashboardHeader.
  const modelId = useSelector(getModel)

  return <HomeHeader account={account} title="Kelly AI" className="kelly-ai-header" modelId={modelId} />
}
